import styled, { ThemedStyledInterface } from "styled-components";
import { ThemeType } from "../../config/theme";

export const styledThemed = styled as unknown as ThemedStyledInterface<ThemeType>;
